// extracted by mini-css-extract-plugin
module.exports = {"root":"_7e098c39e7474f3de55f335a809cd396-less","crop":"_92bb6d1bdeef781fce94676e4b875e18-less"};